/* angular:styles/component:css;29605d2705462ba47665bafb4497f3a636e037eaf4e9a19cf5aa69f46e7d0238;/app/src/app/shared/animations/round-drop-down-list-v2.ts */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.search-box-wrapper {
  margin-top: -54px;
  position: absolute;
  width: 100%;
}
.additional-charges-form {
  background-color: #f2f2f2;
  width: 100%;
  height: 48px;
  border-radius: 16px;
  padding-inline-start: 8px;
  padding-top: 3px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 24px;
  padding-left: 15px;
  margin-bottom: 0;
}
.additional-charges-form:hover {
  background-color: #ffffff;
  box-shadow: 2px 2px 10px rgba(51, 51, 51, 0.2);
}
.additional-charges-clickable {
  cursor: pointer;
}
.additional-charges-div {
  position: relative;
  width: 100%;
}
.additional-charges-img {
  position: absolute;
  left: 52px;
  top: 8px;
}
.code-changeable-img {
  position: absolute;
  right: 8px;
  top: 11px;
}
.spacer {
  padding-bottom: 4px;
}
/*# sourceMappingURL=round-drop-down-list-v2.css.map */
